export default __webpack_public_path__ + "static/step-four-f63e83c73d160ec0e6061f8475b60215.svg";